(function(){
  if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll('#aps .plans .plan').forEach(function(c){
    c.addEventListener('pointermove',function(e){
      if(e.pointerType&&e.pointerType!=='mouse') return;
      var r=c.getBoundingClientRect(), x=(e.clientX-r.left)/r.width, y=(e.clientY-r.top)/r.height;
      c.style.setProperty('--ry',((x-.5)*8).toFixed(2)+'deg');
      c.style.setProperty('--rx',((.5-y)*6).toFixed(2)+'deg');
      c.style.setProperty('--mx',(x*100).toFixed(1)+'%');
      c.style.setProperty('--my',(y*100).toFixed(1)+'%');
    });
    c.addEventListener('pointerleave',function(){c.style.setProperty('--rx','0deg');c.style.setProperty('--ry','0deg');});
  });
})();